import { DownloadIcon } from '@radix-ui/react-icons'
import { Container, Flex, Heading, Section, Skeleton, Table, Text } from '@radix-ui/themes'
import { useCallback } from 'react'
import '../styles.scss'
import { BackOfficeDataServiceAPI } from '@API/data-services/back-office-data-service'
import { ReportsServiceAPI } from '@API/data-services/reports-service'
import { convertDateToIsoDate, formatDateToMonthDayYearString } from '@Components/util/utils'
import { addDays } from 'date-fns'
import { RootState } from '@AppState/redux-store'
import { useSelector } from 'react-redux'

// The coupon export is a daily point-in-time snapshot (not an event range), so we list recent individual days and
// download a single day's file rather than a week range.
const SNAPSHOT_DAYS = 14

export const CouponExportReport = () => {
  const { activeCustomerMetadata } = useSelector((state: RootState) => state.users)

  const handleDownload = useCallback(async (date: Date) => {
    const urlPath = await ReportsServiceAPI.getCouponExportReportUrl(convertDateToIsoDate(date))
    const url = `${BackOfficeDataServiceAPI.getBackOfficeConfig().basePath}${urlPath}`
    const a = document.createElement('a')
    a.href = url
    document.body.appendChild(a)
    a.click()
    a.remove()
    setTimeout(() => URL.revokeObjectURL(url), 0)
  }, [])

  const mapReportRows = () => {
    return new Array(SNAPSHOT_DAYS).fill(null).map((_, i) => {
      const date = addDays(new Date(), -i)

      return (
        <Table.Row key={i}>
          <Table.RowHeaderCell className="report-description-cell">
            <Text>
              Coupon Snapshot (
              {formatDateToMonthDayYearString(date, activeCustomerMetadata?.timezone)})
            </Text>
          </Table.RowHeaderCell>
          <Table.Cell align="right">
            <Flex className="download-cell-container" justify="end" gap="4">
              <Flex
                className="download-cell"
                align="center"
                direction="column"
                onClick={() => handleDownload(date)}>
                <DownloadIcon />
                <Text size="1">CSV</Text>
              </Flex>
            </Flex>
          </Table.Cell>
        </Table.Row>
      )
    })
  }

  return (
    <Container>
      <Section>
        <Heading>Coupon Export</Heading>
      </Section>

      <Skeleton loading={false}>
        <Table.Root>
          <Table.Header>
            <Table.Row>
              <Table.ColumnHeaderCell>Snapshot Date</Table.ColumnHeaderCell>
              <Table.ColumnHeaderCell align="right">Download</Table.ColumnHeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>{mapReportRows()}</Table.Body>
        </Table.Root>
      </Skeleton>
    </Container>
  )
}
